// Unpublished Work © 2020-2026 Deere & Company

import {
    SET_BUSINESS_CONTACT,
    SET_CONFIGURATION,
    SET_CUSTOMER_SEARCH_ACTIVE_TAB,
    SET_DEFAULT_PREFILLED_FACETS
} from '../action-list';
import {Configuration} from '../state/struct/configuration';
import {PreFilledFacets} from '../state/struct/configuration/features/pre-filled-facets';

const setConfiguration = (state, action) => Configuration.update(state, {
    $merge: action.configuration
});

const setBusinessContact = (state, action) => Configuration.update(state, {
    $merge: {
        features: {
            selectBusinessContact: {
                selectedContact: action.selectedContact
            }
        }
    }
});

const clearPreFilledFacets = (state) => Configuration.update(state, {
    $merge: {
        features: {
            ...state.features,
            search: {
                ...state.features.search,
                preFilledFacets: PreFilledFacets({})
            }
        }
    }
});

const setCustomerSearchActiveTab = (state, action) => Configuration.update(state, {
    $merge: {
        customerSearch: {
            ...state.customerSearch,
            activeTab: action.activeTab,
            userExplicitlySelected: action.userExplicitlySelected ?? true
        }
    }
});

export function configurationReducer(state = new Configuration({}), action = {}) {
    const actionHandlers = {
        [SET_CONFIGURATION]: setConfiguration,
        [SET_BUSINESS_CONTACT]: setBusinessContact,
        [SET_CUSTOMER_SEARCH_ACTIVE_TAB]: setCustomerSearchActiveTab,
        [SET_DEFAULT_PREFILLED_FACETS]: clearPreFilledFacets
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
